import React from "react";
import { Helmet } from "react-helmet";
import Logo from "../../assets/img/logos/logoColor.png";

// import components

import HouseList from "../../components/HouseList";
import HeroSlider from "../../components/HeroSlider";
import Location from "../../components/Location";
import PropertiesMapView from "../../components/PropertiesMapView";
import { FaMapMarkerAlt } from "react-icons/fa";

const Home = () => {
  return (
    <>
      {/* SEO Metadatos */}
      <Helmet>
        <title>Agustin Plorutti Inmobiliaria</title>
        <meta
          name="description"
          content="Descubre las mejores propiedades en venta y alquiler. Casas, departamentos y más en Inmobiliaria Agustin Plorutti."
        />
        <meta
          name="keywords"
          content="inmobiliaria, casas en venta, departamentos, alquiler, bienes raíces, propiedades"
        />
        <meta
          property="og:title"
          content="Inmobiliaria Agustin Plorutti - Encuentra tu hogar ideal"
        />
        <meta
          property="og:description"
          content="Descubre las mejores propiedades en venta y alquiler. Casas, departamentos y más en Inmobiliaria Agustin Plorutti."
        />
        <meta
          property="og:image"
          content={Logo} // Actualiza con la URL de tu imagen
        />
        <meta property="og:url" content="https://www.agustinplorutti.com" />
      </Helmet>

      <HeroSlider />
      <div className="sm:pt-6">
        <HouseList />
      </div>

      {/* Mapa de propiedades */}
      <div className="container mx-auto px-4 pb-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-5">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
              <FaMapMarkerAlt className="text-primary" />
              Encontralas en el mapa
            </h2>
            <p className="text-gray-500 mt-1">
              Explorá todas nuestras propiedades por ubicación
            </p>
          </div>
          <a href="/mapa">
            <button className="px-5 py-2.5 bg-primary hover:bg-secondary transition-colors text-white rounded-lg text-sm font-medium">
              Ver mapa completo
            </button>
          </a>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-sm border border-gray-100">
          <PropertiesMapView heightClass="h-[480px]" />
        </div>
      </div>

      <div className="pb-12">
        <div className="container mx-auto bg-gray-400 h-96 rounded-md flex items-center bg-[url('https://peruconstruye.net/wp-content/uploads/2024/03/6.jpg')] bg-cover bg-center">
          <div className="sm:ml-20 text-gray-50 text-center sm:text-left bg-black/50 p-4 rounded-md">
            <h2 className="text-5xl font-bold mb-4">Proyectos inmobiliarios</h2>
            <p className="text-lg inline-block sm:block">
              Descubre las mejores oportunidades de inversión en desarrollos
              inmobiliarios de alta calidad.
            </p>
            <a href="/proyectos">
              <button className="mt-8 px-6 py-3 bg-primary hover:bg-primary/80 transition-colors text-white rounded">
                Explorar proyectos
              </button>
            </a>
          </div>
        </div>
      </div>
      <div className="max-w-[1440px] mx-auto">
        <Location />
      </div>
    </>
  );
};

export default Home;
